export const environment = {
  production: false,
  google_client_id: '91243766353-gdijfemm1kusbq7gfaluah2i1j4pinbt.apps.googleusercontent.com',
  api: {
    baseUrl: 'https://api-dev.simvetmonitor.com/v1/api',
    patients: '/patients/',
    scenarios: '/scenarios/',
    login: '/auth/login',
    register: '/auth/register',
    googleLogin: '/auth/google',
    completeGoogleProfile: '/auth/google/complete-profile',
    user: '/auth/user',
    contacts: '/users/contact',
    institutions: '/institutions',
    feedback: '/users/feedback',
    users: '/users',
    comments: '/comments',
    resetPassword: '/auth/update-password',
    generateResetPasswordToken: '/auth/reset-password',
    sessions: '/sessions',
    elearning: '/elearning',
    notifications: '/users/notifications',
    arrhythmias: '/arrhythmias',
  },
  monitor: 'https://dev.simvetmonitor.com/monitor',
  simulations: {
    baseUrl: 'https://api-dev.simvetmonitor.com/simulations/v1/api',
    sessions: '/simulate-session',
    elearning: '/elearning',
    teachers: '/elearning/teachers',
    sessionNamespace: '/simulation-session',
    websocketUrl: 'https://api-dev.simvetmonitor.com/simulation-session',
    students: '/elearning/students',
    apiKey: 'f5d67711ed39f4e0c6e8208fc6d75932a75d81bcc3e009fe1183add06f712b72',
  },
};
